import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../assets/page-image/cxcyqy/banner.png';
const _hoisted_1 = {
  class: "cxcyqy-detail-wrapper"
};
const _hoisted_2 = {
  class: "cxcyqy-detail-page"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-wrapper"
};
const _hoisted_4 = {
  key: 1,
  class: "detail-content"
};
const _hoisted_5 = {
  class: "company-name"
};
const _hoisted_6 = {
  key: 0,
  class: "company-date"
};
const _hoisted_7 = {
  key: 1,
  class: "company-content"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "back-btn-wrapper"
};
const _hoisted_10 = {
  key: 2,
  class: "empty-wrapper"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getEntrepreneurshipById } from '@/api/entrepreneurship';
export default /*@__PURE__*/_defineComponent({
  __name: 'CxcyqyDetail',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    // 企业详情
    const companyDetail = ref(null);
    // 加载状态
    const loading = ref(true);
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    // 获取企业详情
    const fetchCompanyDetail = async id => {
      try {
        loading.value = true;
        const res = await getEntrepreneurshipById(id);
        if (res.code === 200 || res.code === 0) {
          companyDetail.value = res.data;
        }
      } catch (error) {
        console.error('获取企业详情失败:', error);
      } finally {
        loading.value = false;
      }
    };
    // 返回列表
    const goBack = () => {
      router.go(-1);
    };
    // 页面加载时获取数据
    onMounted(() => {
      const id = route.params.id;
      if (id) {
        fetchCompanyDetail(Number(id));
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "创新创业企业",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : companyDetail.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(companyDetail.value.name), 1), companyDetail.value.settledTime ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 入驻时间：" + _toDisplayString(formatDate(companyDetail.value.settledTime)), 1)) : _createCommentVNode("", true), companyDetail.value.content ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
        innerHTML: companyDetail.value.content
      }, null, 8, _hoisted_8)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        onClick: goBack
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("返回列表", -1)]))]),
        _: 1
      })])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无企业详情", -1)]))]))]), _createVNode(_component_Footer)]);
    };
  }
});